import React from "react";
import { SPOC_COLUMNS } from "../../SpocFields";
import "./index.scss";

// ── SVG Icons ─────────────────────────────────────────────────────────────────
const ViewIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EditIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const DeactivateIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
  </svg>
);

const ActivateIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

// ── SpocTable ─────────────────────────────────────────────────────────────────
const SpocTable = ({ data = [], onView, onEdit, onToggleStatus }) => {
  if (data.length === 0) {
    return (
      <div className="spoc-table-empty">
        <p>No SPOC records found.</p>
      </div>
    );
  }

  return (
    <div className="spoc-table-wrap">
      <div className="spoc-table-scroll">
        <table className="spoc-table">
          <thead>
            <tr>
              {/* <th>#</th> */}
              {SPOC_COLUMNS.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
              <th>Status</th>
              <th className="spoc-th--actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((spoc, idx) => (
              <tr
                key={spoc.id || idx}
                className={!spoc.isActive ? "spoc-tr--inactive" : ""}
              >
                {/* <td className="spoc-td--num">{idx + 1}</td> */}
                {SPOC_COLUMNS.map((col) => (
                  //   <td key={col.key}>{spoc[col.key] || "—"}</td>
                  <td
                    key={col.key}
                    style={{
                      whiteSpace: "normal",
                      overflow: "visible",
                      textOverflow: "unset",
                      wordBreak: "break-word",
                    }}
                  >
                    {spoc[col.key] ?? "—"}
                  </td>
                ))}
                <td>
                  <span
                    className={`spoc-status-badge ${
                      spoc.isActive
                        ? "spoc-status-badge--active"
                        : "spoc-status-badge--inactive"
                    }`}
                  >
                    {spoc.isActive ? "● Active" : "○ Inactive"}
                  </span>
                </td>
                <td className="spoc-td--actions">
                  {/* View just for comment to this. :TODO:*/}
                  {/* <button
                    className="spoc-icon-btn spoc-icon-btn--view"
                    onClick={() => onView(spoc)}
                    title="View details"
                  >
                    <ViewIcon />
                  </button> */}

                  {/* Edit */}
                  <button
                    className="spoc-icon-btn spoc-icon-btn--edit"
                    onClick={() => onEdit(spoc)}
                    title="Edit SPOC"
                  >
                    <EditIcon />
                  </button>

                  {/* Activate / Deactivate */}
                  <button
                    className={`spoc-icon-btn ${
                      spoc.isActive
                        ? "spoc-icon-btn--deactivate"
                        : "spoc-icon-btn--activate"
                    }`}
                    onClick={() => onToggleStatus(spoc)}
                    title={spoc.isActive ? "Deactivate" : "Activate"}
                  >
                    {spoc.isActive ? <DeactivateIcon /> : <ActivateIcon />}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SpocTable;
